import styles from "../styles/ui/Spinner.module.css";

const Spinner = () => <span className={styles.spinner}></span>;

export default Spinner;
